<template>
  <!-- 헤더 컴포넌트 렌더링 -->
  <router-view
    v-if="route.matched.some((_record) => _record.components.header)"
    name="header"
    :class="route.meta.headerClass"
  />

  <main
    id="container"
    class="l-container"
    role="main"
    :class="route.meta.containerClass"
  >
    <h2 class="sr-only">{{ route.meta.containerTitle }}</h2>
    <router-view name="content" />
  </main>

  <!-- 푸터 컴포넌트 렌더링 -->
  <router-view
    v-if="route.matched.some((_record) => _record.components.footer)"
    name="footer"
    :class="route.meta.footerClass"
  />
</template>

<script setup>
/**********************************
 * Settings
 **********************************/
import {
  useGlobalLoadingState,
  useDeviceInfo,
  useHtmlAddClass,
} from "@/composables/useAppComposable.js";

/**********************************
 * Composables Definition
 **********************************/
// 라우트 정보 가져오기
const route = useRoute();

// 전역 UI 로딩 상태 관리
const { isLoading } = useGlobalLoadingState();

// 디바이스 정보 설정
const { setupDeviceInfo } = useDeviceInfo();

// HTML 클래스 설정
const { setupHtmlClass } = useHtmlAddClass();

// 디바이스 정보 및 HTML 클래스 설정  -----------------
onMounted(() => {
  setupDeviceInfo();
  setupHtmlClass();
});
</script>

<style lang="scss" scoped>
.c-loading {
  position: fixed;
}
</style>
